import { createContext, useContext } from "react";
import * as Floating from "./Floating.mjs";
const FloatingOverrideContext = createContext(null),
  useFloating = props => (useContext(FloatingOverrideContext) || Floating.useFloating)?.(props);
export { FloatingOverrideContext, useFloating };